// Components==============
import { faCheck, faPlus, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import React, { useState } from 'react';
import { EvidenceState } from 'typings';
import { framerMountAndScale } from 'utilities/FramerAnimations';
import { getSmartImage } from 'utilities/getSmartImage';

import CircleButton from '../CircleButton/CircleButton';
import EvidenceModal from '../EvidenceModal/EvidenceModal';
import './EvidenceCard.module.scss';
// =========================

export default function EvidenceCard({
  evidence,
  handleAddModalClick,
  handleDelete,
  disableComments,
  imageRef,
  height,
  disableMessageBar,
  isAssessed,
  portfolio,
}: {
  evidence: EvidenceEntity;
  handleAddModalClick?: () => void;
  handleDelete?: (c: EvidenceState) => void;
  disableComments?: boolean;
  imageRef?: React.RefObject<HTMLDivElement>;
  height?: string;
  disableMessageBar?: boolean;
  isAssessed?: boolean;
  portfolio?: boolean;
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const user = useRedux((state) => state?.authentication?.user);

  const isImage = !getSmartImage(evidence.path)?.includes('images/');

  return (
    <>
      <motion.div
        {...framerMountAndScale}
        styleName="wrapper"
        style={{
          height,
        }}
        ref={imageRef}
      >
        {isAssessed && (
          <FontAwesomeIcon icon={faCheck} color="purple" styleName="check" />
        )}
        {evidence.path.includes('.mp4') ? (
          <video preload="metadata">
            <source src={`${evidence?.path}#t=0.5`} type="video/mp4" />
          </video>
        ) : (
          <img
            src={getSmartImage(evidence?.path, evidence?.name)}
            alt={evidence.name}
          />
        )}
        <div
          styleName={`overlay ${isAssessed ? 'check' : ''}`}
          onClick={() => setModalIsOpen(true)}
        >
          <>
            {evidence?.author?.id !== user?.id && (
              <p styleName="creator">
                {evidence.author?.first_name} {evidence.author?.last_name}
              </p>
            )}
            {!portfolio && (
              <>
                <p styleName={!isImage ? 'is-document' : ''}>
                  {evidence?.name}
                </p>
                <p styleName={!isImage ? 'is-document' : ''}>
                  {evidence?.created_at?.slice(0, -8)}
                </p>
              </>
            )}
          </>
          {!!handleAddModalClick && (
            <div styleName="button-wrapper">
              <CircleButton
                icon={faPlus}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddModalClick();
                }}
                color="white-blue"
              />
            </div>
          )}
          {!!handleDelete && (
            <div
              styleName="delete"
              onClick={(e) => {
                e.stopPropagation();
                handleDelete({
                  evidenceId: evidence.id,
                  path: '',
                  name: '',
                });
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </div>
          )}
        </div>
      </motion.div>
      <AnimatePresence>
        {modalIsOpen && (
          <EvidenceModal
            evidence={[evidence]}
            setModalIsOpen={setModalIsOpen}
            handleDelete={handleDelete}
            disableComments={disableComments}
            disableMessageBar={disableMessageBar}
          />
        )}
      </AnimatePresence>
    </>
  );
}
